module.exports = __webpack_public_path__ + "static/media/registered-organizations.b63eee41.svg";